import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-military-calisthenics-pr',
	options: {
		userTags: ['calisthenics'],
	},
	landing: {
		ids: ['loader-military-calisthenics-f', 'age-military-calisthenics-f-pr'],
		route: {
			path: '/military-calisthenics-f-pr',
			name: 'military-calisthenics-f-pr-funnel',
		},
	},
	funnel: {
		id: 'ob-female-military-calisthenics',
		route: {
			path: '/military-calisthenics-f-pr/ob/:page(.*)?',
			name: 'activity-female-military-calisthenics-pr',
		},
		slug: 'activity-female-military-calisthenics-pr',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-military-calisthenics-f-pr',
	},
	upsell: {
		routeNames: ['upsell-military-calisthenics-f'],
	},
}

export default appAreaConfig
